import React from 'react';
import styles from './Toggle.module.scss';
import clsx from 'clsx';

export enum EToggleSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}
interface IToggleProps {
  checked: boolean;
  size: EToggleSize;
  onChange: () => void;
  disabled?: boolean;
  sectionId?: string;
  dataAutomation?: string;
}
export const Toggle: React.FC<IToggleProps> = (props: IToggleProps) => {
  const getClasses = () => {
    const classes = [styles.toggleWrapper];
    if (props.checked) {
      classes.push(styles.on);
    }
    switch (props.size) {
      case EToggleSize.sm:
        classes.push(styles.sm);
        break;
      case EToggleSize.md:
        classes.push(styles.md);
        break;
      case EToggleSize.lg:
        classes.push(styles.lg);
        break;
    }
    if (props.disabled) {
      classes.push(styles.disabled);
    }
    return clsx(...classes);
  };
  const onClickHandler = () => {
    if (props.disabled) return;
    props.onChange();
  };

  return (
    <div
      className={getClasses()}
      onClick={onClickHandler}
      data-automation={
        props.dataAutomation ?? `toggle-${props.sectionId}-${props.checked}`
      }
    >
      <div className={styles.circle} />
    </div>
  );
};
